import employeesPermissions from './employees-permissions.json';

export default {
  employeesPermissions,
};
